// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardConfig_wrapper__OK02P"};